(function() {
    angular
        .module("wzModule")
        .controller("WzQWSConfigurationController", WzQWSConfigurationController)

        WzQWSConfigurationController.$inject = [
            "$rootScope",
            "$scope",
            "$stateParams",
            "wzService",
            "userMessagingService",
            "$uibModal"
        ]

    function WzQWSConfigurationController(
        $rootScope,
        $scope,
        $stateParams,
        wzService,
        userMessagingService,
        $uibModal
    ){
        "use strict"

        $rootScope.title = "Work Zone Configuration | WANCO"

        $scope.editWz = false
        $scope.disableAdjustDisplayPositions = false
        $scope.showMobileNoConfig = false

        $scope.toggleDeviceEnabled = (device) => {

            const shouldBe = !device.enabled
            device.enabled = shouldBe

            const success = (data) => {
                device.enabled = !shouldBe
                if (data) {
                    $scope.applyWzData(data)
                }
            }

            const failure = (error) => {
                device.enabled = !shouldBe
                console.error(error)
            }

            wzService.toggleDeviceEnabled($stateParams.wz_id, device.wz_device_id, shouldBe, success, failure)

        }


        $scope.toggleDeviceOutput = (device) => {

            if (!device.can_be_wz_qws_output) { return }

            const wasBe    = device.is_qws_output
            const shouldBe = !wasBe

            const performToggle = () => {

                const success = (data) => {
                    if (data) {
                        $scope.applyWzData(data)
                    }
                }

                const failure = (error) => {
                    console.error(error)
                }

                wzService.toggleAsQWSOutput($stateParams.wz_id, device.wz_device_id, shouldBe, success, failure)

            }

            // Fix to ensure toggle UI isn't stuck when action cancelled / errorer
            setTimeout(() => {
                $scope.$apply(() => {
                    device.is_qws_output = shouldBe
                    setTimeout(() => {
                        $scope.$apply(() => {
                            device.is_qws_output = wasBe
                        })
                    }, 1)
                })
            }, 1)

            if (shouldBe) {

                performToggle()

            } else {

                $uibModal.open({
                    templateUrl: "app/modals/wz-qws-confirm-unset-output-input-device.view.html",
                    controller:  "WzQwsConfirmUnsetOutputInputDeviceController",
                    resolve: {
                        confirm: () => {
                            return performToggle
                        },
                        deviceType: () => {
                            return "Output"
                        },
                        name: () => {
                            return device.name
                        }
                    }
                }).result.catch(function(res) {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        $scope.toggleDeviceInput = (device) => {

            if (!device.can_be_wz_qws_input) { return }

            const wasBe    = device.is_qws_input
            const shouldBe = !wasBe

            const performToggle = () => {

                const success = (data) => {
                    if (data) {
                        $scope.applyWzData(data)
                    }
                }

                const failure = (error) => {
                    console.error(error)
                }

                wzService.toggleAsQWSInput($stateParams.wz_id, device.wz_device_id, shouldBe, success, failure)

            }

            // Fix to ensure toggle UI isn't stuck when action cancelled / errorer
            setTimeout(() => {
                $scope.$apply(() => {
                    device.is_qws_input = shouldBe
                    setTimeout(() => {
                        $scope.$apply(() => {
                            device.is_qws_input = wasBe
                        })
                    }, 1)
                })
            }, 1)

            if (shouldBe) {

                performToggle()

            } else {

                $uibModal.open({
                    templateUrl: "app/modals/wz-qws-confirm-unset-output-input-device.view.html",
                    controller:  "WzQwsConfirmUnsetOutputInputDeviceController",
                    resolve: {
                        confirm: () => {
                            return performToggle
                        },
                        deviceType: () => {
                            return "Input"
                        },
                        name: () => {
                            return device.name
                        }
                    }
                }).result.catch(function(res) {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        $scope.messageRenderGotoPage = (device, page) => {
            if (device.is_qws_output && device.meta.isMessageBoard) {
                device.message_board.messageRender.currentPage = page
            }
        }

        const resetWzUpdate = () => {
            $scope.wzUpdate = {
                id:                 $scope.wz.id,
                timezone:           $scope.wz.timezone,
                posted_speed_limit: $scope.wz.posted_speed_limit,
                direction:          $scope.wz.direction,
                vehicle_impact:     $scope.wz.vehicle_impact,
                road_name:          $scope.wz.road_name,
                qws: {
                    averaging_window: String($scope.wz.qws.averaging_window),
                    report_interval:  String($scope.wz.qws.report_interval),
                }
            }
        }

        $scope.cancelWzEdit = () => {
            $scope.editWz = false
            resetWzUpdate()
        }

        $scope.changeSpeedLimit = () => {
            if ($scope.wzUpdate.posted_speed_limit < 1) {
                $scope.wzUpdate.posted_speed_limit = 0
            } else if ($scope.wzUpdate.posted_speed_limit > 255) {
                $scope.wzUpdate.posted_speed_limit = 255
            }
        }

        $scope.updateWz = () => {

            if ($scope.editWzForm.$valid) {

                $scope.submitted = true

                const success = (data) => {
                    $scope.editWz = false
                    $scope.applyWzData(data)
                }

                const failure = (error) => {
                    $scope.cancelWzEdit()
                    userMessagingService.error(error)
                }

                wzService.update($scope.wzUpdate, success, failure)

            }
        }

        // $scope.cleanPostedSpeedLimit = () => {
        //     const input = document.getElementById("posted_speed_limit")
        //     if (input !== undefined && input.value !== undefined) {
        //         input.value = input.value.replace(/\D/g, "")
        //     }
        // }

        const sortByDisplayPosition = () => {
            $scope.wzDevices.sort((a, b) => { return a.display_position > b.display_position ? 1 : -1 })
        }

        const adjustDisplayPositions = (deviceID) => {

            const newDisplayPositions = []

            for (const device of $scope.wzDevices) {
                newDisplayPositions.push({
                    wz_device_id:         device.wz_device_id,
                    new_display_position: device.display_position
                })
            }

            const success = (data) => {
                gtag("event", "workzone_move_device", { wz_id: $stateParams.wz_id, device_id: deviceID })

                if (data) {
                    $scope.applyWzData(data)
                }

                $scope.disableAdjustDisplayPositions = false
            }

            const failure = (error) => {
                console.error(error)
                $scope.disableAdjustDisplayPositions = false
            }

            wzService.adjustDisplayPositions($stateParams.wz_id, newDisplayPositions, success, failure)

            setTimeout(() => {
                $scope.disableAdjustDisplayPositions = false
            }, 150)
        }

        $scope.moveDisplayPositionUp = (device) => {

            if (device.display_position <= 1) { return }

            $scope.disableAdjustDisplayPositions = true

            // Move Up = Numeric Down

            const otherDevice = $scope.wzDevices[device.display_position - 2]
            otherDevice.display_position = otherDevice.display_position + 1
            device.display_position      = device.display_position - 1

            sortByDisplayPosition()
            adjustDisplayPositions(device.device_id)

        }

        $scope.moveDisplayPositionDown = (device) => {

            if (device.display_position >= $scope.wzDevices.length) { return }

            // Move Down = Numeric Up

            const otherDevice = $scope.wzDevices[device.display_position]
            otherDevice.display_position = otherDevice.display_position - 1
            device.display_position      = device.display_position + 1

            sortByDisplayPosition()
            adjustDisplayPositions(device.device_id)

        }

        $scope.addDevice = (deviceID) => {

            const success = (data) => {
                $scope.applyWzData(data)
            }

            const failure = (error) => {
                console.error(error)
            }

            wzService.addDevice($stateParams.wz_id, deviceID, success, failure)

        }

        $scope.removeDevice = function(device) {

            const performRemove = () => {
                $scope.removeDeviceFromWZ(device.device_id)
            }

            if (!device.is_qws_output && !device.is_qws_input) {
                performRemove()
                return
            }

            $uibModal.open({
                templateUrl: "app/modals/wz-qws-confirm-remove-output-input-device.view.html",
                controller:  "WzQwsConfirmRemoveOutputInputDeviceController",
                resolve: {
                    confirm: () => {
                        return performRemove
                    },
                    deviceType: () => {
                        return device.is_qws_output ? "Output" : "Input"
                    },
                    name: () => {
                        return device.name
                    }
                }
            }).result.catch(function(res) {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }


        $scope.closeMobileNoConfig = () => {
            $scope.showMobileNoConfig = false
        }

        $scope.configureOutput = (device) => {
            if (window.innerWidth < 600) {
                $scope.showMobileNoConfig = true
                return
            }

            $scope.loadingOutputConfiguration = true

            const retrievedConfig = (config) => {

                gtag("event", "workzone_edit_device", { action: "begin", wz_id: $stateParams.wz_id, device_id: device.device_id })

                $scope.loadingOutputConfiguration = false

                $uibModal.open({
                    templateUrl: "app/modals/wz-qws-configure-output.view.html",
                    controller:  "WzQwsConfigureOutputController",
                    backdrop: "static",
                    keyboard: false,
                    windowClass: "wzQwsOutputModal",
                    resolve: {
                        device: () => {
                            return device
                        },
                        wz: () => {
                            return $scope.wz
                        },
                        config: () => {
                            return config
                        },
                        cancel: () => {
                            return () => gtag("event", "workzone_edit_device", { action: "cancel", wz_id: $stateParams.wz_id, device_id: device.device_id })
                        },
                        saveConfig: () => {
                            return (newConfig) => {
                                wzService.setOutputConfiguration($stateParams.wz_id, device.wz_device_id, newConfig, (updatedWZ) => {
                                    gtag("event", "workzone_edit_device", { action: "complete", wz_id: $stateParams.wz_id, device_id: device.device_id })
                                    $scope.applyWzData(updatedWZ)
                                })
                            }
                        }
                    }
                }).result.catch(function(res) {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }

            const failedRetrieveConfig = (error) => {

                $scope.loadingOutputConfiguration = false

                console.log(error)

            }

            wzService.getOutputConfiguration($stateParams.wz_id, device.wz_device_id, retrievedConfig, failedRetrieveConfig)

        }

        $scope.$watch("wz", () => {
            if ($scope.wz && $scope.wz.hasOwnProperty("id") && $scope.wz.type === "QWS") {
                resetWzUpdate()
            }
        })
    }
})()
